<template>
    <b-card no-body>
        <b-modal id="create-or-update" size="lg" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <traffic-fine-create-or-update v-model="trafficFine" :editing="editing" :errors="errors" :company-name="companyName"></traffic-fine-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="editing ? update : createOrUpdate" :disabled="isFormInvalid"></v-executer></template>
        </b-modal>
        <b-modal id="approval-request-modal" v-model="isApprovalModalVisible" :title="approvalRequest.title" size="lg" no-close-on-esc no-close-on-backdrop>
            <approval-request-modal-content
                v-if="isApprovalModalVisible"
                v-model="approvalRequest.form"
                :personnel="approvalRequest.allPersonnel"
                :approvers="approvalRequest.approvers"
                v-on:search-personnel="searchAllPersonnel"
            />
            <template #modal-footer>
                <v-executer
                    :loading="loading"
                    text="Güncelle"
                    :action="createOrUpdate"
                    :disabled="!approvalRequest.form.selectedOrderedBy || !approvalRequest.form.selectedApprover || !approvalRequest.form.description"
                ></v-executer>
            </template>
        </b-modal>
        <b-modal id="view-traffic-fine-modal" v-model="isViewModalVisible" size="lg" :title="`Ceza Detayları - ${$safe(viewItemDetails, 'ReportNumber')}`" hide-footer>
            <traffic-fine-detail v-if="viewItemDetails" :details="viewItemDetails" />
        </b-modal>
        <v-table
            ref="table"
            :buttons="buttons"
            :fields="fields"
            name="traffic-fine"
            pagination="server"
            search
            :items-provider="provider"
            :add-callback="createNew"
            button-alignment="justify-content-start"
            initial-sort-by="FineDate"
            :initial-sort-desc="true"
        ></v-table>
    </b-card>
</template>

<script>
import { BCard } from "bootstrap-vue";
import TrafficFineCreateOrUpdate from "./components/TrafficFineCreateOrUpdate.vue";
import ApprovalRequestModalContent from "./components/ApprovalRequestModalContent.vue";
import EmployeeOperationsApi from "@/api/employee-operations";
import moment from "moment";
import Additional from "@/utilities/additional";
import Auth from "@/utilities/auth";
import TrafficFineDetail from "./components/TrafficFineDetail.vue";
import { createOrUpdate } from "echarts/lib/util/throttle";

export default {
    components: {
        BCard,
        TrafficFineCreateOrUpdate,
        ApprovalRequestModalContent,
        TrafficFineDetail,
    },
    data() {
        return {
            fields: [
                { name: "Personel", key: "Employee.FullName", thClass: "w-15", tdClass: "text-nowrap", sortable: true, tdClass: "text-nowrap" },
                { name: "Ceza", component: true, componentOptions: { name: "traffic-fine/TrafficFine" }, thClass: "w-15", tdClass: "text-nowrap" },
                { name: "Durum", key: "Status", thClass: "w-20", sortable: false, component: true, componentOptions: { name: "traffic-fine/StatusBadge" } },
                { name: "Ceza Tutarı (TL)", key: "DiscountedFineAmountStr", tdClass: "text-right text-nowrap", thClass: "w-14", sortable: true },
                //{ name: "İndirimli Ceza Tutarı (TL)", key: "DiscountedFineAmountStr", thClass: "w-15", tdClass: "text-right text-nowrap" },
                { name: "Personel Tutar (TL)", key: "DriverAmountStr", thClass: "w-15", tdClass: "text-right text-nowrap" },
                { name: "Şirket Tutar (TL)", key: "CompanyAmountStr", thClass: "w-15", tdClass: "text-right text-nowrap" },
                { name: "Ceza Tarihi", key: "FineDate", thClass: "w-15", tdClass: "text-right text-nowrap" },
                { name: "Banka 2", key: "Banka2" },
                { name: "Ceza Puanı", key: "TrafficFine.Point", thClass: "w-10", tdClass: "text-right text-nowrap" },
                {
                    name: "Kalan Resmi Ceza Puanı",
                    key: "PointsLast1Year",
                    component: true,
                    componentOptions: { name: "traffic-fine/PointStatusBadge" },
                    thClass: "w-10 text-center",
                    tdClass: "text-right",
                },
            ],
            buttons: [
                { text: "İncele", key: "view", icon: "EyeIcon", variant: "info", action: this.view },
                { text: "Düzenle", key: "edit", icon: "Edit2Icon", variant: "secondary", action: this.edit, condition: (item) => item.Status !== 2 && item.Status !== 3 },
                //{ text: "Pasife Al", key: "deactivate", icon: "UserXIcon", variant: "warning", action: this.deactivate, condition: (item) => item.Status !== 2 && item.Status !== 3 },
                //{ text: "Sil", key: "delete", icon: "TrashIcon", variant: "danger", action: this.delete, condition: (item) => item.Status === 2 },
                { text: "Belge İndir", key: "download", icon: "DownloadIcon", variant: "success", action: this.download, condition: (item) => item.Document },
            ],
            editing: false,
            loading: false,
            errors: {},
            trafficFine: {
                Id: null,
                TrafficFineId: null,
                EmployeeId: null,
                FineDate: null,
                FineAmount: null,
                PaymentDate: null,
                PaymentPlace: 0,
                BankId: null,
                TaxAdministrationId: null,
                ReportNumber: null,
                DriverAmount: null,
                CompanyAmount: null,
                PaidAmount: null,
                Employee: null,
                NotifyDate: null,
                NotifyOrigin: null,
                Banka2: false,
                Document: null,
                DocumenBase: null,
                Address: null,
                Latitude: null,
                Longitude: null,
                PlateId: null,
                FinePoint: null,
                Description: null,
            },
            isApprovalModalVisible: false,
            approvalRequest: {
                action: null,
                title: "",
                item: null,
                allPersonnel: [],
                approvers: [],
                form: {
                    selectedOrderedBy: null,
                    selectedApprover: null,
                    description: "",
                },
            },
            searchTimer: null,
            isViewModalVisible: false,
            viewItemDetails: null,
        };
    },
    methods: {
        // handleApprovalSubmit() {
        //     this.loading = true;
        //     const form = this.approvalRequest.form;

        //     const requestData = {
        //         Id: this.approvalRequest.item.Id,
        //         OrderedByEmployeeId: form.selectedOrderedBy.Id,
        //         ApproverUserId: form.selectedApprover.UserId,
        //         Description: form.description,
        //     };

        //     EmployeeOperationsApi.TrafficFine.Deactivate(requestData)
        //         .then((res) => {
        //             this.$result(res);
        //             if (res.data.Success) {
        //                 this.isApprovalModalVisible = false;
        //                 this.$refs.table.refresh();
        //             }
        //         })
        //         .catch((err) => {
        //             this.$result(null, err);
        //         })
        //         .finally(() => {
        //             this.loading = false;
        //         });
        // },
        searchAllPersonnel(searchKey) {
            if (!searchKey || searchKey.length < 2) return;

            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => {
                EmployeeOperationsApi.Employee.Search(searchKey)
                    .then((res) => {
                        if (res.data.Success) {
                            this.approvalRequest.allPersonnel = res.data.Data.map((d) => ({
                                ...d,
                                FullName: d.FullName,
                                Id: d.Id,
                            }));
                        }
                    })
                    .catch((err) => this.$result(null, err));
            }, 500);
        },
        async fetchApprovers(trafficFineId) {
            try {
                const res = await EmployeeOperationsApi.TrafficFine.GetApprovers(trafficFineId);
                if (res.data.Success) {
                    this.approvalRequest.approvers = res.data.Data;
                } else {
                    this.approvalRequest.approvers = [];
                }
            } catch (err) {
                this.approvalRequest.approvers = [];
                this.$result(null, err);
            }
        },
        async update() {
            this.approvalRequest.action = "deactivate";
            this.approvalRequest.title = `${this.$safe(this.trafficFine,'Employee.FullName')} - Trafik Cezası Pasife Alma Onayı`;
            this.approvalRequest.item = this.trafficFine;
            this.approvalRequest.form = { selectedOrderedBy: null, selectedApprover: null, description: "" };

            this.$refs.table.rowLoading(true);
            await this.fetchApprovers(this.trafficFine.Id);
            this.$refs.table.rowLoading(false);

            this.isApprovalModalVisible = true;
        },
        view(item) {
            this.viewItemDetails = item;
            this.isViewModalVisible = true;
        },
        clearForm() {
            this.editing = false;
            this.trafficFine.Id = null;
            this.trafficFine.TrafficFineId = null;
            this.trafficFine.EmployeeId = null;
            this.trafficFine.Employee = null;
            this.trafficFine.FineDate = null;
            this.trafficFine.FineAmount = null;
            this.trafficFine.DiscountedFineAmount = null;
            this.trafficFine.PaymentDate = null;
            this.trafficFine.PaymentPlace = 0;
            this.trafficFine.ReportNumber = null;
            this.trafficFine.DriverAmount = 0;
            this.trafficFine.CompanyAmount = 0;
            this.trafficFine.PaidAmount = null;
            this.trafficFine.NotifyDate = null;
            this.trafficFine.NotifyOrigin = null;
            this.trafficFine.Banka2 = false;
            this.trafficFine.Document = null;
            this.trafficFine.DocumentBase = null;
            this.trafficFine.BankId = null;
            this.trafficFine.TaxAdministrationId = null;
            this.trafficFine.Address = null;
            this.trafficFine.Latitude = null;
            this.trafficFine.Longitude = null;
            this.trafficFine.PlateId = null;
            this.trafficFine.Point = null;
            this.trafficFine.Description = null;
        },
        createNew() {
            this.clearForm();
            this.$showModal("create-or-update");
        },
        provider(data) {
            return EmployeeOperationsApi.TrafficFine.Table(data);
        },
        edit(item) {
            this.clearForm();
            this.editing = true;

            this.trafficFine.Id = item.Id;
            this.trafficFine.TrafficFineId = item.TrafficFine?.Id || null;
            this.trafficFine.EmployeeId = item.Employee?.Id || null;
            this.trafficFine.Employee = item.Employee;
            this.trafficFine.FineDate = moment(item.FineDate, "DD.MM.YYYY HH:mm:ss").format("YYYY-MM-DDTHH:mm:ss");
            this.trafficFine.FineAmount = item.FineAmount;
            this.trafficFine.DiscountedFineAmount = item.FineAmount;
            this.trafficFine.PaymentDate = item.PaymentDate ? moment(item.PaymentDate, "DD.MM.YYYY").format("YYYY-MM-DD") : null;
            this.trafficFine.PaymentPlace = item.PaymentPlace;
            this.trafficFine.ReportNumber = item.ReportNumber;
            this.trafficFine.DriverAmount = item.DriverAmount || 0;
            this.trafficFine.CompanyAmount = item.CompanyAmount || 0;
            this.trafficFine.PaidAmount = item.PaidAmount;
            this.trafficFine.Banka2 = item.Banka2;
            this.trafficFine.NotifyDate = item.NotifyDate ? moment(item.NotifyDate, "DD.MM.YYYY").format("YYYY-MM-DD") : null;
            this.trafficFine.NotifyOrigin = item.NotifyOrigin;
            this.trafficFine.Document = item.Document;
            this.trafficFine.DocumentBase = item.Document;
            this.trafficFine.BankId = item.BankId || null;
            this.trafficFine.TaxAdministrationId = item.TaxAdministrationId || null;
            this.trafficFine.Address = item.Address || null;
            this.trafficFine.Latitude = item.Latitude || null;
            this.trafficFine.Longitude = item.Longitude || null;
            this.trafficFine.PlateId = item.PlateId || null;
            this.trafficFine.Description = item.Description || null;
            this.$showModal("create-or-update");
        },
        download(item) {
            this.$refs.table.rowLoading(true);
            Additional.GetBlobFile(item.Document)
                .then((res) => {
                    const name = [["Trafik Cezası", item.Employee?.FullName, item.ReportNumber].join("-"), Additional.GetExtension(item.Document)].join(".");
                    Additional.DownloadFile(res.data, name);
                    this.$refs.table.rowLoading(false);
                })
                .catch((err) => {
                    this.$result(null, err);
                    this.$refs.table.rowLoading(false);
                });
        },
        async createOrUpdate() {
            this.loading = true;
            this.errors = {};
            const fd = new FormData();

            for (const key in this.trafficFine) {
                const value = this.trafficFine[key];
                const numericFields = ["FineAmount", "DiscountedFineAmount", "DriverAmount", "CompanyAmount", "PaidAmount"];

                if (numericFields.includes(key)) {
                    let finalValue = "0";
                    if (value !== null && value !== undefined && value !== "") {
                        finalValue = String(value).replace(".", ",");
                    }

                    if (key === "DriverAmount") {
                        fd.append("EmployeeAmount", finalValue);
                    } else {
                        fd.append(key, finalValue);
                    }
                } else if (key !== "Document" && value !== null && value !== undefined) {
                    fd.append(key, value);
                }
            }

            if (this.trafficFine.Document instanceof File) {
                fd.append("Document", this.trafficFine.Document);
            }

            this.loading = true;
            
            if(this.editing){
                const form = this.approvalRequest.form;
                if(this.trafficFine.DocumentBase != this.trafficFine.Document && this.trafficFine.DocumentBase != null){
                    fd.append('FileDeleted',true)
                }else { fd.append('FileDeleted',false) }
                fd.append("OrderedByEmployeeId",form.selectedOrderedBy.Id)
                fd.append("ApproverUserId",form.selectedApprover.UserId)
                fd.append("ChangeDescription",form.description)
            }

            EmployeeOperationsApi.TrafficFine.CreateOrUpdate(this.editing, fd)
                .then((res) => {
                    this.$result(res);
                    if (res.data.Success) {
                        this.isApprovalModalVisible = false;
                        this.$hideModal("create-or-update");
                        this.$refs.table.refresh();
                    }
                })
                .catch((err) => {
                    if (err.response?.data?.ErrorType === "validation.error") {
                        this.errors = err.response.data.Data;
                        this.$toast.error("Lütfen formdaki hataları düzeltin.");
                    } else {
                        this.errors = {};
                        this.$result(null, err);
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        delete(item) {
            this.$confirm("Silmek istediğinize emin misiniz?", `Bu işlem ${item.Employee?.FullName} personeline ait ${item.FineDate} tarihli trafik cezasını silecektir ve geri alınamaz.`).then(
                (result) => {
                    if (result) {
                        EmployeeOperationsApi.TrafficFine.Delete(item.Id)
                            .then((res) => {
                                if (res.data.Success) {
                                    this.$refs.table.refresh();
                                }
                                this.$result(res);
                            })
                            .catch((err) => {
                                this.$result(null, err);
                            });
                    }
                }
            );
        },
    },
    computed: {
        isFormInvalid() {
            const tf = this.trafficFine;
            if (!tf.ReportNumber || !tf.FineDate || !tf.TrafficFineId || !tf.PlateId || !tf.EmployeeId || !tf.NotifyDate || !tf.Document) {
                return true;
            }
            return false;
        },
        companyName() {
            return Auth.companyName;
        },
    },
};
</script>

<style>

</style>
